import React, { useEffect } from 'react';

const AppStoreRedirect = () => {
  // UPDATE THESE WITH YOUR ACTUAL APP LINKS
  const APP_STORE_URL = 'https://apps.apple.com/hk/app/lulu-hk/id6502274123'; // iOS link
  const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.luluhk.luluhk'; // Android link
  const FALLBACK_URL = 'https://www.luluhk.com'; // Optional: your website if neither

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // iOS detection (iPhone, iPad, iPod)
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      window.location.replace(APP_STORE_URL);
      return;
    }

    // Android detection
    if (/android/i.test(userAgent)) {
      window.location.replace(PLAY_STORE_URL);
      return;
    }

    // Optional: For other devices (desktop, etc.), do nothing or redirect to website
    window.location.replace(FALLBACK_URL);
  }, []);

  // Loading UI while detection happens
  return (
    <div></div>
  );
};

export default AppStoreRedirect;